import React, { Component } from "react";
import { Link } from "react-router-dom";
import { MDBContainer, MDBRow, MDBCol, MDBCard, MDBCardHeader } from "mdbreact";
import HomePageNews from "./News/HomePageNews";
import { GetData } from "../api/service";
import AliceCarousel from "react-alice-carousel";
import "react-alice-carousel/lib/alice-carousel.css";
import {
  Container,
  Grid,
  Typography,
} from "@material-ui/core";
import { Button, Divider, Modal } from "antd";
import moment from "moment";
import { DownloadOutlined } from "@ant-design/icons";
import { History } from "./PanduAbout/AboutDescription";
import StickyButton from "./StickyButton";
import Announcements from "./Announcements";
import RecentNews from "./RecentNews";
import HomePageEvents from "./News/HomePageEvents";
import VideoHomePage from "./Video/VideoHomePage";
import HomePageCertificates from "./News/HomePageCertificates";
import HomePageFeatured from "./Essentials/HomePageFeatured";
import StudentsCornerHomePage from "./StudentsCorner/StudentsCornerHomePage";
import KnowYourFaculty from "./KnowYourFaculty/KnowYourFaculty";
import Hightlights from "./Hightlights";
import CollegeMap from "./CollegeMap/CollegeMap";
import ProminentSection from "./HomepageSections/ProminentSection";
import HeroHeader from "./HomepageSections/HeroHeader";
import PartnershipStrip from "./HomepageSections/PartnershipStrip";
import FlashnewsHeader from "./HeaderComponent/Header";
export default class HomePagePandu extends Component {
  state = {
    events: [],
    isLoaded: false,
    showHoliday: false,
    holidayData: {},
  };

  componentDidMount() {
    this.loadData();
  }

  loadData = () => {
    GetData(`/getupcomingevents`).then((resp) => {
      console.log("events", resp);
      this.setState((prevState) => {
        return {
          ...prevState,
          events: resp,
          isLoaded: true,
        };
      });
    });

    GetData(`/checkiftodayisholiday`).then((resp) => {
      if (resp != null) {
        this.setState(
          (prevState) => {
            return {
              ...prevState,
              showHoliday: resp.status,
              holidayData: {
                ...resp.data,
              },
            };
          },
          () => {
            this.showHoliday();
          }
        );
      }
    });
  };

  showHoliday() {
    if (this.state.showHoliday) {
      Modal.info({
        title: this.state.holidayData?.title,
        content: (
          <div>
            <div>
              {Array.isArray(this.state.holidayData.upload_info) &&
                this.state.holidayData.upload_info.map((el) => (
                  <img src={el.url} style={{ width: "100%" }} />
                ))}
            </div>
            From :{" "}
            {moment(this.state.holidayData?.start_date).format("DD/MM/YYYY")} to{" "}
            {moment(this.state.holidayData?.end_date).format("DD/MM/YYYY")}
            <div
              style={{ margin: 0 }}
              dangerouslySetInnerHTML={{
                __html: this.state.holidayData?.description,
              }}
            ></div>
            {/* <br />
          <br />
          <br />
          {this.state.holidayData?.upload_info?.map((el, index) => <>
            <Button type="primary" icon={<DownloadOutlined />} size="small" onClick={() => window.open(`${el.url}}`)}>File {++index}</Button>&nbsp;
          </>
          )} */}
          </div>
        ),
        onOk() {},
        centered: true,
      });
    }
  }
  render() {
    return (
      <div className="fontFix">
        <FlashnewsHeader />
        <HeroHeader />
        {/* <Grid container>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <RecentNews />
          </Grid>
          <Grid item xs={12} sm={12} md={6} lg={6}>
            <Grid container>
              <div style={{ padding: 20 }}>
                <Typography
                  variant="h5"
                  style={{ fontWeight: 700, fontSize: 24 }}
                  gutterBottom
                >
                  About The College
                </Typography>
                <Typography
                  variant="body2"
                  style={{ textAlign: "justify", fontSize: 17 }}
                >
                  &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Rangia College
                  is the premier institution of higher education on the north
                  bank of the Brahmaputra in the district of Kamrup. Founded on
                  August 5, 1963, the college has rendered pioneering services
                  to the community by catering to the needs of the vast and
                  extensive area inhabited predominantly by socially and
                  economically backward segments of the population. Rangia is a
                  historically and strategically important place occupying a
                  prominent position in the history of pre-independent as well
                  as post independent Assam...{" "}
                  <Link to="/aboutus/about">Read More</Link>
                  <br />
                  <br />
                  <VideoHomePage viewTitle={false} />
                </Typography>
              </div>

             
            </Grid>
          </Grid>
        </Grid> */}

        <div>
          <Grid container>
            <Grid item xs={12} sm={12} md={4} lg={4} stye={{ backgroundColor: "#F8F9FA" }}>
              <div
                style={{
                  padding: 20,
                  marginTop: "-10px",
                }}
              >
                <Divider
                  orientation="left"
                  style={{
                    fontWeight: 700,
                    fontSize: 20,
                    borderColor: "#ABB2B9",
                    color: "#192F59",
                  }}
                >
                  Principal's Message
                </Divider>
                <div style={{ width: "100%", position: "relative" }}>
                  <img
                    src="/images/Principal-Rangia.jpg"
                    className="img-wrap-image"
                  />

                  <div className="p-warp-image">
                    <Typography
                      variant="body2"
                      gutterBottom
                      style={{ textAlign: "justify", padding: 10, fontSize: 14 }}
                    >
                      It gives me immense pleasure to welcome all of you to
                      Rangia College, where education means all-round
                      development of students. I thank you for your interest in
                      this exceptional institution which has recorded more than
                      five (05) decades of constant development, in course of
                      which it has accomplished much, making it one (01) of the
                      colleges recognised for its excellence and therefore, much
                      sought after by the fresh applicants. While academic
                      excellence is our major trust, the college is also devoted
                      to prepare the students for life, groom them to face the
                      challenges of tomorrow and encourage them to be socially
                      relevant....
                    </Typography>

                    <div style={{ textAlign: "right" }}>
                      <Link to="/administrations/principal-message">
                        <Button style={{background:"#B22222", color:'white'}}>Know More</Button>
                      </Link>
                    </div>
                  </div>
                </div>
              </div>
            </Grid>
            <Grid
              item
              xs={12}
              sm={12}
              md={3}
              lg={3}
              style={{ backgroundColor: "#1E3760" }}
            >
              <div style={{ padding: 20 }}>
                <Divider
                  orientation="left"
                  style={{
                    fontWeight: 700,
                    fontSize: 20,
                    borderColor: "white",
                    color: "white",
                  }}
                >
                  OUR VISION
                </Divider>
                <Typography variant="body2" style={{ color: "#EAECEE" }}>
                  We have a vision of building the college as 
                  a centre of academic excellence within the next ten years time.
                </Typography>
              </div>
              <div style={{ padding: 20 }}>
                <Divider
                  orientation="left"
                  style={{
                    fontWeight: 700,
                    fontSize: 20,
                    borderColor: "white",
                    color: "white",
                  }}
                >
                  OUR MISSION
                </Divider>
                <Typography variant="body2" style={{ color: "#EAECEE" }}>
                 
                  Rangia College solemnly pledges to relentlessly pursue the Mission of “Transmission of knowledge, wisdom, skill and competence from one generation to another.
                    
                </Typography>
            
              </div>
            </Grid>

            <Grid
              item
              xs={12}
              sm={12}
              lg={5}
              md={5}
              style={{ backgroundColor: "#B22222" }}
            >
               <div style={{ padding: 20 }}>
                <Divider
                  orientation="left"
                  style={{
                    fontWeight: 700,
                    fontSize: 20,
                    borderColor: "white",
                    color: "white",
                  }}
                >
                  OUR GOAL/OBJECTIVES
                </Divider>
                <Typography variant="body2" style={{ color: "#EAECEE" }}>
                  <ul style={{ marginLeft: "-25px" }}>
                    <li>
                    To give the educational facilities to the young generation particularly belonging to the socially and economically backward communities of the entire North Kamrup area.
                    </li>
                    <li>
                    To impart education to the students of Arts, Science and Commerce faculties with the purpose of making them capable resourceful citizens.
                    </li>
                    <li>
                    To impart education in vocational subjects.
                    </li>
                    <li>
                    To introduce new subjects and courses to keep pace with the changing situations.
                    </li>
                    <li>
                    To provide exclusive facilities to the students for their physical intellectual and cultural development.
                    </li>
                    <li>
                    To create a healthy academic atmosphere in the locality.
                    </li>
                    <li>
                    To produce quality students equipped with moral, spiritual, aesthetic values to face the challenges of life.
                    </li>
                    <li>
                    To create a pragmatic approach in the minds of the students the socio-economic realities of life.
                    </li>
                    <li>
                    To take such other academic programmes as may be deemed necessary from time to time.
                    </li>
                  </ul>
                </Typography>
                
              </div>
            </Grid>
          </Grid>
        </div>

        <div style={{ minHeight: 400 }}>
          <br />
          <HomePageEvents />

          <br />
          <br />
        </div>

        <div style={{ backgroundColor: "#FFFFFF" }}>
          <div style={{ padding: 20 }}>
            <Grid container spacing={2}>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <Divider
                  orientation="left"
                  style={{
                    fontWeight: 700,
                    fontSize: 20,
                    borderColor: "#ABB2B9",
                    color:"#003366",
                  }}
                >
                  STUDENT NOTICES
                </Divider>
                <HomePageNews
                  type="COLLEGE_ACADEMIC_NOTICE"
                  link="/notifications/academic"
                />
              </Grid>

              <Grid item xs={12} sm={12} md={3} lg={3}>
                <Divider
                  orientation="left"
                  style={{
                    fontWeight: 700,
                    fontSize: 20,
                    borderColor: "#ABB2B9",
                    color:"#003366",
                  }}
                >
                  ADMINISTRATIVE NOTICES
                </Divider>
                <HomePageNews
                  type="COLLEGE_ADMIN_NOTICE"
                  link="/notifications/administrative"
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <Divider
                  orientation="left"
                  style={{
                    fontWeight: 700,
                    fontSize: 20,
                    borderColor: "#ABB2B9",
                    color:"#003366",
                  }}
                >
                  TENDERS
                </Divider>
                <HomePageNews
                  type="COLLEGE_TENDER"
                  link="/notifications/tender"
                />
              </Grid>
              <Grid item xs={12} sm={12} md={3} lg={3}>
                <Divider
                  orientation="left"
                  style={{
                    fontWeight: 700,
                    fontSize: 20,
                    borderColor: "#ABB2B9",
                    color:"#003366",
                  }}
                >
                  DOWNLOADS
                </Divider>
                <HomePageNews
                  type="COLLEGE_DOWNLOADS"
                  link="/notifications/downloads"
                />
              </Grid>
            </Grid>
          </div>
        </div>

        <div></div>

       

        

        <br />
        <br />

       

       

        

        <div style={{ minHeight: 400 }}>
          <br />
          <KnowYourFaculty />

          <br />
          <br />
        </div>

        

        {/* <div style={{ backgroundColor: "#f9f9f9", padding: 10 }}>
      
          <Hightlights />
        </div> */}

        <div style={{ minHeight: 400 }}>
          <ProminentSection />

          <br />
          <br />
        </div>

        {/* <div style={{ minHeight: 400 }}>
          <br />
          <VideoHomePage />

          <br />
          <br />
        </div> */}

        <PartnershipStrip />
      
       


        <HomePageFeatured />
      </div>
    );
  }
}
